/*
 * Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

import api from "@/config/api"
import Vue from "vue"

export default {
  namespaced: true,

  state: {
    data: {},
    status: null,
  },

  mutations: {
    /**
     * Commit lanEvent to state
     *
     * @param meetings
     */
    load(state, data) {
      // event data
      state.data = data

      // update status
      state.status = "success"
    },

    /**
     * Commit load error to state
     */
    loadError(state) {
      state.status = "error"
    },
  },

  actions: {
    /**
     * Load LAN event data from server
     */
    load({ commit }) {
      Vue.http.get(api.LAN_EVENT()).then(
        response => {
          commit("load", response.body)
        },
        () => {
          commit("loadError")
        }
      )
    },

    /**
     * Update LAN event on server
     *
     * @param data
     * @returns {Promise<any>}
     */
    update({ commit }, { data }) {
      return new Promise((resolve, reject) => {
        Vue.http.put(api.LAN_EVENT(), data).then(
          response => {
            commit("load", response.body)
            resolve(response.data)
          },
          response => {
            reject(response)
          }
        )
      })
    },
  },

  getters: {
    /**
     * Get whether data has successfully loaded
     *
     * @returns {boolean}
     */
    hasLoaded: state => state.status === "success",

    /**
     * Get LAN event data
     *
     * @returns {*}
     */
    eventData: state => state.data,
  },
}
